import AddBannerForm from 'app/form/AddBannerForm';
import React from 'react';

const AddBanner = () => {
	return (
		<div>
			<AddBannerForm />
		</div>
	);
};

export default AddBanner;
